export default __webpack_public_path__ + "static/media/HDTX_Keterbukaan Informasi 2022.83da20b6.pdf";